module.exports = __webpack_public_path__ + "img/sfq-h4.0376c2fc.png";